import { useNavigate } from "react-router-dom";

const LOGO_URL = process.env.REACT_APP_LOGO_URL || "https://customer-assets.emergentagent.com/job_talentmeet-app/artifacts/w1exeb5m_IMG-20260127-WA0008.jpg";

export default function Footer({ variant = "full" }) {
  const navigate = useNavigate();

  // Simple footer for internal pages
  if (variant === "simple") {
    return (
      <footer className="bg-gray-900 text-gray-400 py-6 px-4">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm">&copy; 2026 TalentMeet. All rights reserved.</p>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-sm">
            <button onClick={() => navigate("/about")} className="hover:text-white transition-colors">About</button>
            <button onClick={() => navigate("/terms")} className="hover:text-white transition-colors">Terms</button>
            <button onClick={() => navigate("/privacy")} className="hover:text-white transition-colors">Privacy</button>
            <a href="mailto:support@talentmeet.in" className="hover:text-white transition-colors">Contact</a>
          </div>
        </div>
      </footer>
    );
  }

  // Full footer for homepage and major pages
  return (
    <footer className="bg-gray-900 text-gray-400 py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img src={LOGO_URL} alt="TalentMeet" className="h-8 w-8 rounded-lg" />
              <span className="font-bold text-white">TalentMeet</span>
            </div>
            <p className="text-sm leading-relaxed">
              Where Talent Meets Opportunity. Connecting artists, trainers, and enterprises in the entertainment industry.
            </p>
          </div>

          {/* Platform Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Platform</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => navigate("/browse")} className="hover:text-white transition-colors">
                  Browse Talents
                </button>
              </li>
              <li>
                <button onClick={() => navigate("/services")} className="hover:text-white transition-colors">
                  Opportunities
                </button>
              </li>
              <li>
                <button onClick={() => navigate("/login")} className="hover:text-white transition-colors">
                  Sign In
                </button>
              </li>
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => navigate("/about")} className="hover:text-white transition-colors">
                  About Us
                </button>
              </li>
              <li>
                <a href="mailto:support@talentmeet.in" className="hover:text-white transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => navigate("/privacy")} className="hover:text-white transition-colors">
                  Privacy Policy
                </button>
              </li>
              <li>
                <button onClick={() => navigate("/terms")} className="hover:text-white transition-colors">
                  Terms of Service
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm">&copy; 2026 TalentMeet. All rights reserved.</p>
          <p className="text-sm">
            Support:{" "}
            <a href="mailto:support@talentmeet.in" className="text-violet-400 hover:text-violet-300 transition-colors">
              support@talentmeet.in
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
